export default __webpack_public_path__ + "static/media/whimstay.b2e94c4b.png";